<template>
    <section class="section faq ">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-xl-8">
                    <div class="section__header">
                        <h2 class="h1">frequently ask questions</h2>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-12 col-xl-10">
                    <div class="accordion" id="accordion">
                        <div class="accordion-item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="600ms">
                            <h5 class="accordion-header" id="headingOne">
                                <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    What is ChatGPT?
                                </button>
                            </h5>
                            <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                                data-bs-parent="#accordion">
                                <div class="accordion-body">
                                    <p>
                                        analyses the speaker's face and gaze during a video
                                        conversation to maintain eye contact before changing the
                                        camera position. io at a later time. Clear, consistent,
                                        and professional voices for marketing, explainer,
                                        product, and YouTube videos.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="900ms">
                            <h5 class="accordion-header" id="headingTwo">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    How is Chatsonic different from ChatGPT by Open AI?
                                </button>
                            </h5>
                            <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                                data-bs-parent="#accordion">
                                <div class="accordion-body">
                                    <p>
                                        analyses the speaker's face and gaze during a video
                                        conversation to maintain eye contact before changing the
                                        camera position. io at a later time. Clear, consistent,
                                        and professional voices for marketing, explainer,
                                        product, and YouTube videos.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item content__space wow fadeInUp" data-wow-duration="600ms"
                            data-wow-delay="1200ms">
                            <h5 class="accordion-header" id="headingThree">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    What format are the files in?
                                </button>
                            </h5>
                            <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                                data-bs-parent="#accordion">
                                <div class="accordion-body">
                                    <p>
                                        analyses the speaker's face and gaze during a video
                                        conversation to maintain eye contact before changing the
                                        camera position. io at a later time. Clear, consistent,
                                        and professional voices for marketing, explainer,
                                        product, and YouTube videos.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item content__space wow fadeInUp" data-wow-duration="600ms"
                            data-wow-delay="1500ms">
                            <h5 class="accordion-header" id="headingFour">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    What is ChatGPT used for?
                                </button>
                            </h5>
                            <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
                                data-bs-parent="#accordion">
                                <div class="accordion-body">
                                    <p>
                                        analyses the speaker's face and gaze during a video
                                        conversation to maintain eye contact before changing the
                                        camera position. io at a later time. Clear, consistent,
                                        and professional voices for marketing, explainer,
                                        product, and YouTube videos.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item content__space wow fadeInUp" data-wow-duration="600ms"
                            data-wow-delay="1500ms">
                            <h5 class="accordion-header" id="headingFive">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                    How can I support this site?
                                </button>
                            </h5>
                            <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive"
                                data-bs-parent="#accordion">
                                <div class="accordion-body">
                                    <p>
                                        analyses the speaker's face and gaze during a video
                                        conversation to maintain eye contact before changing the
                                        camera position. io at a later time. Clear, consistent,
                                        and professional voices for marketing, explainer,
                                        product, and YouTube videos.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "FAQ",
    }
</script>


// WEBPACK FOOTER //
// src/components/page_components/home-8/FAQ.vue